import { FADE_DURATION } from "./consts";

/**
 * Stop a video playing after a specific delay.
 *
 * @param    {HTMLElement} video The HTML5 video element currently
 *                                      playing
 * @param    {number} delay             Delay in miliseconds before stopping.
 */
export default function stopVideoAfterDelay(video, delay = FADE_DURATION) {
  if (!video.paused) {
    setTimeout(() => video.pause(), delay);
  }
}
